import React from 'react';
import { Users } from 'react-feather';

import Avatar from '../../../avatar/Avatar';
import { generateDarkColorFromString } from '../../../../utils/generateColorBasedOnString';

const iconSizes = {
    xs: 10,
    sm: 14,
    md: 14,
    lg: 18,
    xl: 22
};

/** No lugar das iniciais, o ícone de grupo. A cor sai do id do grupo, e não do nome,
 *  para não mudar quando ele é renomeado.
 */
const GroupAvatar = ({ group, size = 'lg' }) => {
    const groupId = group?.id;
    const { dark, light } = React.useMemo(
        () => generateDarkColorFromString(`internal-chat-group-${groupId}`),
        [groupId]
    );

    return (
        <Avatar
            name={group?.name}
            size={size}
            style={{ backgroundColor: light, color: dark }}
            iconElement={<Users size={iconSizes[size] || iconSizes.lg} />}
        />
    );
};

export default React.memo(GroupAvatar);
